// extracted by mini-css-extract-plugin
module.exports = {"root":"pcQL_b6p2JHFVn-oX1tQE"};